import { render, staticRenderFns } from "./selectImagen.vue?vue&type=template&id=3f565579"
import script from "./selectImagen.vue?vue&type=script&lang=ts"
export * from "./selectImagen.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports